import { defaultDropAnimationSideEffects } from '@dnd-kit/core';

const DEFAULT_TRANSLATE = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
const DROP_ANIMATION_CONFIG = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.5'
      }
    }
  })
};

export { DEFAULT_TRANSLATE, DROP_ANIMATION_CONFIG };
